var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined",
    attrs: {
      "disable-filtering": "",
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c('v-subheader', [_vm._v("Mouser Client Credentials")]), _c('v-divider')];
      },
      proxy: true
    }, {
      key: "item.apiKey",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-text-field', _vm._b({
          on: {
            "input": _vm.emit
          },
          model: {
            value: item.apiKey,
            callback: function callback($$v) {
              _vm.$set(item, "apiKey", $$v);
            },
            expression: "item.apiKey"
          }
        }, 'v-text-field', _vm.attrs_input__table, false))];
      }
    }, {
      key: "item.isActive",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-switch', _vm._b({
          staticClass: "d-inline-block ml-1 mr-n3",
          on: {
            "change": _vm.emit
          },
          model: {
            value: item.isActive,
            callback: function callback($$v) {
              _vm.$set(item, "isActive", $$v);
            },
            expression: "item.isActive"
          }
        }, 'v-switch', _vm.attrs_switch, false))];
      }
    }, {
      key: "item.pull",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "tile": "",
            "width": "48",
            "height": "48",
            "color": "red"
          },
          on: {
            "click": function click($event) {
              return _vm.pull(item);
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-minus")])], 1)];
      }
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('v-divider'), _c('v-row', {
          attrs: {
            "no-gutters": ""
          }
        }, [_c('v-spacer'), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-btn', {
          attrs: {
            "text": "",
            "icon": "",
            "tile": "",
            "width": "48",
            "height": "48",
            "color": "primary"
          },
          on: {
            "click": _vm.push
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)], 1)];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }